import { forwardRef } from "react";
import { Form } from "ui";
import FormRef from "../types/FormRef";

export type InvoiceModel = {};

type InvoiceFormProps = {
    data?: InvoiceModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: InvoiceModel) => void;
};

const InvoiceForm = forwardRef<FormRef, InvoiceFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data ?? {}}
                errors={errors}
                fields={{}}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                Nothing to configure
            </Form>
        );
    },
);

export default InvoiceForm;
